import CN from './cn.js'
import EN from './en.js'

export default {
    "ZH-CN": CN,
    "EN-US": EN
}